import { service } from '@/utils/request'
class planning {
  // 企划详情-用户侧
  static getPlanningDetail (params) {
    return service.get(`/api/planning/details`, { params })
  }
  // 获取企划列表
  static getPlanningList (params) {
    return service.get(`/api/planning/list`, { params })
  }
  // 提交企划投稿
  static postPlanning (params) {
    return service.post(`/api/planning/contribute`, params)
  }
  static getMyPlanList (params) {
    return service.get('/api/planning/my_list', { params })
  }
  static getMyPlanDetail (params) {
    return service.get('/api/planning/work_details', { params })
  }
  static getMyPlanTipStatus (params) {
    return service.get('/api/planning/tips_status', { params })
  }
}

export default planning
